<template>
    <div class="agreement" v-if="list.length">

        <div class="row" v-for="(item, index) in list" :key="index" @click="goToAgreement(item)">
          <span class="text-style">{{item.name}}</span>
          <img class="arrow-style" src="@/assets/arrow_right.png"/>
        </div>
       
    </div>

    <!-- 无数据时渲染空状态 -->
    <div v-else class="empty-container">
        <img class="empty-icon" src="@/assets/empty-order.png"/>
        <div class="empty-text">暂无协议</div>
    </div>   
</template>

<script>

import { getAgreementList } from "@/api/user";
export default {
    data() {
        return {
            name: 'Agreement',
            list: [],
        };
    },
    mounted() {
        this.getAgreement();
    },
    methods: {
        getAgreement() {
            getAgreementList({appType: 'U'})
                .then(res => {
                    this.list = res;
                    console.log('获取列表成功', res);
                })
                .catch(err => {
                    console.error('获取列表失败', err);
                });
        },
        goToAgreement(item) {
            if(window.__wxjs_environment === "miniprogram"){
                this.uni.navigateTo('/user/agreementUrl?url='+item.url );
            }else{
                window.location.href = item.url;
            }
            
        },
       
    }
    
}
</script>

<style lang="less" scoped>

.empty-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 100vh;
          .empty-icon {
                width: 200px;
                height: 200px;
          }
          .empty-text {
                font-size: 30px;
                color: #848992;
                margin-top: 40px;
          }
     }
.agreement {
    background: white;
    padding: 20px;
    .row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 34px;
        padding-bottom: 34px;
        padding-left: 10px;
        padding-right: 10px;
        .text-style {
            font-weight: bold;
            font-size: 32px;
            color: #24262B;
        }
        .arrow-style {
            width: 36px;
            height: 36px;
        }
      }
}

h1 {
    font-size: 24px;
    margin-bottom: 10px;
}

p {
    font-size: 16px;
}
</style>